import { render } from "./BallSelect.vue?vue&type=template&id=64badcb6&scoped=true"
import script from "./BallSelect.vue?vue&type=script&lang=js"
export * from "./BallSelect.vue?vue&type=script&lang=js"

import "./BallSelect.vue?vue&type=style&index=0&id=64badcb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64badcb6"

export default script